export const call_tracking = {
  name: 'call-tracking',
  title: 'call-tracking.breadcrumb.title',
  icon: () => import('@shared/components/icon/sidebar/icon-call-tracking.vue'),
  route: { name: 'call-tracking.index' },
  children: [
    {
      title: 'call-tracking.breadcrumb.number.index',
      route: { name: 'call-tracking.number.index' }
    },
    {
      title: 'shared.breadcrumb.stats.title',
      route: { name: 'call-tracking.stats.index' }
    },
    {
      title: 'call-tracking.breadcrumb.integration.index',
      route: { name: 'call-tracking.integration.index' }
    }
  ]
};
